
const parseDoubleToFloat = (double) => {
    return parseFloat(double).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
}

export { parseDoubleToFloat }